import React from "react"
import styles from "./index.module.css"
import { useNavigate } from "react-router-dom"
import { Button } from "antd"
import Footer from "../footer/footer"

const NotFoundPage = () => {
	const navigate = useNavigate()
	return (
		<div className={styles.main_page}>
			<div className={styles.background}>
				<h3 className={styles.error_title}>Page not found</h3>
				<Button onClick={() => navigate("/")} type="primary" className={styles.button}>
					Go home
				</Button>
			</div>
			<Footer />
		</div>
	)
}

export { NotFoundPage };
